module.exports = __webpack_public_path__ + "img/help-content-5.402f1906.png";